import { createSelector } from 'reselect'

const userDataSelector = state => state.user.data

export default createSelector(
	[ userDataSelector ],
	userData => userData
)
